import React from 'react';
import ReactDOM from 'react-dom';
import Routing from './Component/Routing';
ReactDOM.render(<Routing/>,document.getElementById('root'))